import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';

import { trackByProp } from '@frontend/vanilla/core';
import { first } from 'rxjs/operators';

import { LanguageSwitcherItem } from './language-switcher.models';
import { LanguageSwitcherService } from './language-switcher.service';

@Component({
    selector: 'vn-seo-language-links',
    templateUrl: 'seo-language-links.html',
})
export class SeoLanguageLinksComponent implements OnInit {
    private languageSwitcherService = inject(LanguageSwitcherService);
    private changeDetectorRef = inject(ChangeDetectorRef);

    languages: LanguageSwitcherItem[];
    readonly trackByNativeName = trackByProp<LanguageSwitcherItem>('nativeName');

    ngOnInit() {
        this.languageSwitcherService
            .getLanguageSwitcherData(true)
            .pipe(first())
            .subscribe((languages: LanguageSwitcherItem[]) => {
                this.languages = languages;
                this.changeDetectorRef.detectChanges();
            });
    }
}
